/**
 * Ryan O'Dowd
 * 2025-06-13
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale}) => {
  return {
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: globalScale * 4,
    },
  };
};

export default getStyles;
